import React, { useState } from 'react';
import { translate } from '../Services/translation';
import { post } from '../Services/http';
import LoadingSpinner from './LoadingSpinner';

const NewsletterOptin = () => {
  const [value, setValue] = useState("");
  const [resultMessage, setResultMessage] = useState("");
  const [resultSuccess, setResultSuccess] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    var optInModel = {
        Email: value,
        Source: "NewsletterFooterWeb"
    }
    await post('/api/mailchimp/optin', optInModel)
      .then((result) => {
          setResultSuccess(translate(true)),
          setResultMessage(translate('newsletter.subscribed'))
      }).catch(() => {
          setResultSuccess(translate(false)),
          setResultMessage(translate('newsletter.error'))
      });
      setIsLoading(false);
  }

  const handleChange = (e) => {
      setValue(e.target.value);
  }

  return (<>
    <h3>{translate("footer.newsletter.header")}</h3>
    <form onSubmit={handleSubmit}>
      <input id="newsletter-footer__input" type="text" value={value} onChange={(e) => handleChange(e)} placeholder={translate("footer.newsletter.placeholder")} />
      <button aria-label="subscribe" type="submit" disabled={isLoading}>{isLoading ? <LoadingSpinner /> : <i className="newsletter-footer__icon color-white ph-arrow-right"></i>}</button>
    </form> 
    {resultMessage && <span className={`newsletter-footer__message newsletter-footer__message--${resultSuccess ? "success" : "error"}`}>{resultMessage}</span>}
    <div className="news-letter-signup__text [ text-medium text-large-from-medium lh-2 ]">
      {translate("footer.newsletter.text")}
    </div>
  </>);
};

export default NewsletterOptin;
